export default "__VITE_ASSET__57337c26__"